<template>
  <div id="jci-program-create" class="program-edit-container">
    <!-- Premium Page Header -->
    <v-card elevation="20" class="premium-header-card mb-6 overflow-hidden">
      <div class="header-gradient-bg">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <div class="d-flex align-center">
            <div class="header-icon-box">
              <v-icon size="48" color="white">mdi-pencil-box-outline</v-icon>
            </div>
            <div class="ml-6">
              <h1 class="header-title white--text mb-1">Edit Event Program</h1>
              <p class="header-subtitle white--text mb-0">
                Configure event details, host information, and participant
                settings
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-chip
              color="rgba(255,255,255,0.2)"
              text-color="white"
              class="step-progress-chip"
            >
              <v-icon small left>mdi-information-outline</v-icon>
              Step {{ step }} of 3
            </v-chip>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Modern Stepper -->
    <v-stepper v-model="step" class="modern-stepper elevation-12 mb-6">
      <!-- Professional Stepper Header -->
      <v-stepper-header class="stepper-header-modern">
        <!-- Step 1 -->
        <div class="stepper-step modern-step-item">
          <div class="step-icon-circle" :class="{ active: step >= 1 }">
            <v-icon color="white" size="24">mdi-calendar-check</v-icon>
          </div>
          <span class="step-text">Event Details</span>
        </div>

        <div class="step-divider-line" :class="{ active: step > 1 }"></div>

        <!-- Step 2 -->
        <div class="stepper-step modern-step-item">
          <div class="step-icon-circle" :class="{ active: step >= 2 }">
            <v-icon color="white" size="24">mdi-home-group</v-icon>
          </div>
          <span class="step-text">Host Details</span>
        </div>

        <div class="step-divider-line" :class="{ active: step > 2 }"></div>

        <!-- Step 3 -->
        <div class="stepper-step modern-step-item">
          <div class="step-icon-circle" :class="{ active: step >= 3 }">
            <v-icon color="white" size="24">mdi-account-multiple</v-icon>
          </div>
          <span class="step-text">Participant Details</span>
        </div>
      </v-stepper-header>
      <br />
      <!-- Loading State -->
      <div v-if="LoadingFlag" class="text-center py-12">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <p class="mt-6 text-h6 primary--text font-weight-600">
          Loading program data...
        </p>
      </div>

      <v-stepper-items v-show="!LoadingFlag">
        <!-- Step 1: Event Details -->
        <v-stepper-content step="1">
          <v-card class="premium-card-modern">
            <!-- Premium Card Header -->
            <div class="card-header-gradient">
              <div class="card-header-backdrop"></div>
              <div class="card-header-modern pa-8">
                <div class="d-flex align-center">
                  <div class="card-icon-badge">
                    <v-icon size="40" color="white">mdi-calendar-check</v-icon>
                  </div>
                  <div class="ml-4">
                    <h2 class="card-header-title white--text mb-1">
                      Event Details
                    </h2>
                    <p class="card-header-subtitle white--text mb-0">
                      Configure basic event information
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <v-form ref="form3" v-model="valid3" lazy-validation>
              <v-card-text class="card-body-modern pa-8">
                <!-- Info Banner -->
                <div class="info-banner mb-6">
                  <v-icon color="#667eea" class="mr-2"
                    >mdi-lightbulb-outline</v-icon
                  >
                  <span
                    ><span class="text-danger font-weight-bold">*</span>
                    indicates required field</span
                  >
                </div>
                <v-container fluid class="pa-0">
                  <!-- Event Type & Status -->
                  <v-row class="mb-4">
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-tag-multiple</v-icon
                        >
                        <span class="text-danger">*</span> Event Type
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        :loading="EventTypeOptionsLoading"
                        :items="EventTypeOptions"
                        :rules="EventTypeRules"
                        v-model="EventType"
                        placeholder="Select event type"
                        dense
                        clearable
                        required
                        outlined
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-check-circle</v-icon
                        >
                        <span class="text-danger">*</span> Status
                      </div>
                      <v-select
                        :items="StatusTypeOptions"
                        v-model="StatusType"
                        :rules="StatusTypeRules"
                        required
                        outlined
                        dense
                        placeholder="Select status"
                        class="field-input"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <!-- Event Info Cards -->
                  <v-row v-if="EventType > 0" class="mb-6">
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="info-card">
                        <div class="info-header">
                          <v-icon small color="primary" class="mr-2"
                            >mdi-file-document</v-icon
                          >
                          <h6 class="mb-0 font-weight-700">Description</h6>
                        </div>
                        <div class="info-text">
                          {{ SelectedEventType.description }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="info-card">
                        <div class="info-header">
                          <v-icon small color="primary" class="mr-2"
                            >mdi-shield-check</v-icon
                          >
                          <h6 class="mb-0 font-weight-700">Eligibility</h6>
                        </div>
                        <div class="info-text">
                          {{ SelectedEventType.eligibility_content }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="info-card">
                        <div class="info-header">
                          <v-icon small color="primary" class="mr-2"
                            >mdi-gift</v-icon
                          >
                          <h6 class="mb-0 font-weight-700">Subsidy</h6>
                        </div>
                        <div class="info-text">
                          {{ SelectedEventType.subsidy_amount_txt }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="info-card">
                        <div class="info-header">
                          <v-icon small color="primary" class="mr-2"
                            >mdi-receipt</v-icon
                          >
                          <h6 class="mb-0 font-weight-700">Receipt</h6>
                        </div>
                        <div class="info-text">
                          {{ SelectedEventType.issue_receipt_txt }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-divider class="my-6"></v-divider>

                  <!-- Dates & Venue -->
                  <v-row class="mb-4" v-if="EventType > 0">
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-calendar-start</v-icon
                        >
                        <span class="text-danger">*</span> From Date
                      </div>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            v-model="FromDate"
                            placeholder="Select start date"
                            readonly
                            v-on="on"
                            outlined
                            dense
                            class="field-input"
                            validate-on-blur
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="FromDate"
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-calendar-end</v-icon
                        >
                        <span class="text-danger">*</span> To Date
                      </div>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            v-model="ToDate"
                            placeholder="Select end date"
                            readonly
                            v-on="on"
                            outlined
                            dense
                            class="field-input"
                            validate-on-blur
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="ToDate"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-text-box</v-icon
                        >
                        Custom Name
                      </div>
                      <v-text-field
                        v-model="CustomName"
                        :rules="CustomNameRules"
                        placeholder="Custom event name (optional)"
                        outlined
                        dense
                        class="field-input"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-map-marker</v-icon
                        >
                        Venue <small class="text-muted">(optional)</small>
                      </div>
                      <v-text-field
                        v-model="Venue"
                        :rules="VenueRules"
                        placeholder="Event location"
                        outlined
                        dense
                        class="field-input"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Location Fields -->
                  <v-row class="mb-4" v-if="EventType > 0">
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-map</v-icon
                        >
                        <span class="text-danger">*</span> State
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        :loading="StateIdOptionsLoading"
                        :items="StateIdOptions"
                        :rules="StateIdRules"
                        v-model="StateId"
                        placeholder="Select state"
                        required
                        outlined
                        dense
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-city</v-icon
                        >
                        <span class="text-danger">*</span> District
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        :loading="DistrictIdOptionsLoading"
                        :items="DistrictIdOptions"
                        :rules="DistrictIdRules"
                        v-model="DistrictId"
                        placeholder="Select district"
                        required
                        outlined
                        dense
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-home-city</v-icon
                        >
                        <span class="text-danger">*</span> City
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        :loading="CityIdOptionsLoading"
                        :items="CityIdOptions"
                        :rules="CityIdRules"
                        v-model="CityId"
                        placeholder="Select city"
                        required
                        outlined
                        dense
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <!-- Registration Limits -->
                  <v-row class="mb-4" v-if="EventType > 0">
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-account-multiple</v-icon
                        >
                        Max Registrations Overall
                      </div>
                      <v-text-field
                        v-model="RegistrationOverallCount"
                        :rules="RegistrationOverallCountRules"
                        placeholder="0 for unlimited"
                        hint="Maximum participants"
                        persistent-hint
                        outlined
                        dense
                        class="field-input"
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="3" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-account-check</v-icon
                        >
                        Max Per User
                      </div>
                      <v-text-field
                        v-model="RegistrationUserCount"
                        :rules="RegistrationUserCountRules"
                        placeholder="0 for unlimited"
                        hint="Per person limit"
                        persistent-hint
                        outlined
                        dense
                        class="field-input"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <!-- Card Actions -->
              <v-divider></v-divider>
              <v-card-actions class="card-actions-modern pa-6">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  size="large"
                  elevation="4"
                  class="action-btn continue-btn px-8"
                  @click="validateStep(1)"
                >
                  <v-icon left>mdi-chevron-right</v-icon>
                  Continue
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-stepper-content>

        <!-- Step 2: Host Details -->
        <v-stepper-content step="2">
          <v-card class="premium-card-modern">
            <!-- Premium Card Header -->
            <div class="card-header-gradient">
              <div class="card-header-backdrop"></div>
              <div class="card-header-modern pa-8">
                <div class="d-flex align-center">
                  <div class="card-icon-badge">
                    <v-icon size="40" color="white">mdi-home-group</v-icon>
                  </div>
                  <div class="ml-4">
                    <h2 class="card-header-title white--text mb-1">
                      Host Details
                    </h2>
                    <p class="card-header-subtitle white--text mb-0">
                      Define who is hosting this event
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <v-form ref="form2" v-model="valid2" lazy-validation>
              <v-card-text class="card-body-modern pa-8">
                <!-- Info Banner -->
                <div class="info-banner mb-6">
                  <v-icon color="#667eea" class="mr-2"
                    >mdi-lightbulb-outline</v-icon
                  >
                  <span
                    ><span class="text-danger font-weight-bold">*</span>
                    indicates required field</span
                  >
                </div>

                <v-container fluid class="pa-0">
                  <v-row class="mb-4">
                    <!-- Hosted by JCI India Switch -->
                    <v-col cols="12" sm="6" md="4" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-home-group</v-icon
                        >
                        <span class="text-danger">*</span> Hosted by
                        <strong>JCI India?</strong>
                      </div>
                      <v-switch
                        v-model="HostType"
                        :label="`${HostType == 1 ? 'Yes' : 'No'}`"
                        class="field-input mt-2"
                      ></v-switch>
                    </v-col>

                    <!-- Zone Field (shown when HostType is false/0) -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      v-if="!HostType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-map-marker-radius</v-icon
                        >
                        <span class="text-danger">*</span> Zone
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        :loading="HostZoneCodeOptionsLoading"
                        :items="HostZoneCodeOptions"
                        :rules="HostZoneCodeRules"
                        v-model="HostZoneCode"
                        placeholder="Select zone"
                        dense
                        clearable
                        required
                        outlined
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>

                    <!-- LOM Field (shown when HostType is false/0) -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      v-if="!HostType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-office-building</v-icon
                        >
                        <span class="text-danger">*</span> LOM
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="HostLomCode"
                        :rules="HostLomCodeRules"
                        :items="HostLomCodeOptions"
                        :loading="HostLomCodeOptionsLoading"
                        dense
                        clearable
                        required
                        outlined
                        class="field-input"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <!-- Card Actions -->
              <v-divider></v-divider>
              <v-card-actions class="card-actions-modern pa-6">
                <v-btn
                  color="grey"
                  size="large"
                  elevation="2"
                  class="action-btn previous-btn px-8"
                  @click="step = 1"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  Previous
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  size="large"
                  elevation="4"
                  class="action-btn continue-btn px-8"
                  @click.prevent="validateStep(2)"
                >
                  <v-icon left>mdi-chevron-right</v-icon>
                  Continue
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-stepper-content>

        <!-- Step 3: Participant Details -->
        <v-stepper-content step="3">
          <v-card class="premium-card-modern">
            <!-- Premium Card Header -->
            <div class="card-header-gradient">
              <div class="card-header-backdrop"></div>
              <div class="card-header-modern pa-8">
                <div class="d-flex align-center">
                  <div class="card-icon-badge">
                    <v-icon size="40" color="white"
                      >mdi-account-multiple</v-icon
                    >
                  </div>
                  <div class="ml-4">
                    <h2 class="card-header-title white--text mb-1">
                      Participant Settings
                    </h2>
                    <p class="card-header-subtitle white--text mb-0">
                      Configure eligibility and participant rules
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <v-form ref="form1" v-model="valid1" lazy-validation>
              <v-card-text class="card-body-modern pa-8">
                <!-- Info Banner -->
                <div class="info-banner mb-6">
                  <v-icon color="#667eea" class="mr-2"
                    >mdi-lightbulb-outline</v-icon
                  >
                  <span
                    ><span class="text-danger font-weight-bold">*</span>
                    indicates required field</span
                  >
                </div>

                <v-container fluid class="pa-0">
                  <v-row wrap class="mb-4">
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-map-marker-radius</v-icon
                        >
                        Can members from all zones participate?
                      </div>
                      <v-switch
                        v-model="ParticipantZoneType"
                        :label="`${ParticipantZoneType == 1 ? 'Yes' : 'No'}`"
                        class="mt-2"
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="!ParticipantZoneType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-checkbox-marked-multiple</v-icon
                        >
                        <span class="text-danger">*</span> Zones ({{
                          ParticipantZoneCode.length
                        }}
                        selected)
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="ParticipantZoneCode"
                        :rules="ParticipantZoneCodeRules"
                        :items="ParticipantZoneCodeOptions"
                        :loading="ParticipantZoneCodeOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select zones"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 1)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="!ParticipantZoneType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-office-building</v-icon
                        >
                        Can members from all LOs participate?
                      </div>
                      <v-switch
                        v-model="ParticipantLomType"
                        :label="`${ParticipantLomType == 1 ? 'Yes' : 'No'}`"
                        class="mt-2"
                      ></v-switch>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="!ParticipantZoneType && !ParticipantLomType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-checkbox-marked-multiple</v-icon
                        >
                        <span class="text-danger">*</span> Local Organizations
                        ({{ ParticipantLomCode.length }} selected)
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="ParticipantLomCode"
                        :rules="ParticipantLomCodeRules"
                        :items="ParticipantLomCodeOptions"
                        :loading="ParticipantLomCodeOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select LOs"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 6)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row wrap class="mb-4">
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-account</v-icon
                        >
                        Non-members can participate?
                      </div>
                      <v-switch
                        v-model="ParticipantNonMember"
                        :label="`${ParticipantNonMember == 1 ? 'Yes' : 'No'}`"
                        class="mt-2"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="field-col">
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-badge-account</v-icon
                        >
                        All designations participate?
                      </div>
                      <v-switch
                        v-model="ParticipantAllDesignation"
                        :label="`${
                          ParticipantAllDesignation == 1 ? 'Yes' : 'No'
                        }`"
                        class="mt-2"
                      ></v-switch>
                    </v-col>
                  </v-row>

                  <!-- Designation Filters -->
                  <v-row
                    wrap
                    v-if="!ParticipantAllDesignation"
                    class="designation-section"
                  >
                    <v-col cols="12" class="mb-4">
                      <h5 class="font-weight-700">
                        <v-icon color="primary" small class="mr-2"
                          >mdi-filter-multiple</v-icon
                        >
                        Designation Requirements
                      </h5>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="3"
                      v-if="!NationalDesigntionType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-filter</v-icon
                        >
                        National Designations ({{ NationalDesigntion.length }})
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="NationalDesigntion"
                        :rules="NationalDesigntionRules"
                        :items="NationalDesigntionOptions"
                        :loading="NationalDesigntionOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select designations"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 2)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="3"
                      v-if="!ZoneDesigntionType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-filter</v-icon
                        >
                        Zone Designations ({{ ZoneDesigntion.length }})
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="ZoneDesigntion"
                        :rules="ZoneDesigntionRules"
                        :items="ZoneDesigntionOptions"
                        :loading="ZoneDesigntionOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select designations"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 3)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="3"
                      v-if="!LomDesigntionType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-filter</v-icon
                        >
                        LO Designations ({{ LomDesigntion.length }})
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="LomDesigntion"
                        :rules="LomDesigntionRules"
                        :items="LomDesigntionOptions"
                        :loading="LomDesigntionOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select designations"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 4)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="3"
                      v-if="!CommitteeDesigntionType"
                      class="field-col"
                    >
                      <div class="form-field-label">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-filter</v-icon
                        >
                        Committee ({{ CommitteeDesigntion.length }})
                      </div>
                      <v-autocomplete
                        :reduce="(option) => option.value"
                        v-model="CommitteeDesigntion"
                        :rules="CommitteeDesigntionRules"
                        :items="CommitteeDesigntionOptions"
                        :loading="CommitteeDesigntionOptionsLoading"
                        item-text="text"
                        item-value="value"
                        hint="Select designations"
                        persistent-hint
                        dense
                        chips
                        clearable
                        required
                        outlined
                        multiple
                        class="field-input"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item, 5)"
                          >
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <!-- Card Actions -->
              <v-divider></v-divider>
              <v-card-actions class="card-actions-modern pa-6">
                <v-btn
                  color="grey"
                  size="large"
                  elevation="2"
                  class="action-btn previous-btn px-8"
                  @click="step = 2"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  Previous
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  size="large"
                  elevation="4"
                  class="action-btn submit-btn px-8"
                  @click="validateStep(3)"
                  :loading="SubmitFlag"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-form ref="form4" v-model="valid4" lazy-validation></v-form>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  data() {
    return {
      step: 1,
      valid1: true,
      valid2: true,
      valid3: true,
      valid4: true,
      valid5: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      SendOtpFlag: false,
      SendOtpLoadingFlag: false,
      VerifyOtpFlag: false,
      VerifyOtpLoadingFlag: false,
      ResendOtpFlag: false,

      MemberId: "",

      MemberName: "",

      StatusTypeOptions: [
        { value: 0, text: "Inactive" },
        { value: 1, text: "Approved" },
        { value: 2, text: "Pending" },
        { value: 3, text: "Rejected" },
        { value: 4, text: "Cancelled" },
      ],
      StatusTypeRules: [(v) => !!v || "Stage Type is required"],
      StatusType: "--Select Options--",

      // For Step 1

      SelectedEventType: {},

      EventTypeRules: [(v) => !!v || "Event type is required"],
      EventType: "",
      EventTypeOptions: [],
      EventTypeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      CustomName: "",
      CustomNameRules: [],

      Venue: "",
      VenueRules: [],

      StateIdRules: [(v) => !!v || "State is required"],
      StateId: "",
      StateIdOptions: [],
      StateIdOptionsLoading: false,

      DistrictIdRules: [(v) => !!v || "District is required"],
      DistrictId: "",
      DistrictIdOptions: [],
      DistrictIdOptionsLoading: false,

      CityIdRules: [(v) => !!v || "City is required"],
      CityId: "",
      CityIdOptions: [],
      CityIdOptionsLoading: false,

      RegistrationOverallCount: "",
      RegistrationOverallCountRules: [
        (v) => v === 0 || !!v || "Registration overall count is required",
      ],

      RegistrationUserCount: "",
      RegistrationUserCountRules: [
        (v) => v === 0 || !!v || "Registration per user count is required",
      ],

      // For Step 2

      HostType: "",

      HostZoneCodeRules: [],
      HostZoneCode: "",
      HostZoneCodeOptions: [(v) => !!v || "Zone is required"],
      HostZoneCodeOptionsLoading: false,

      HostLomCodeRules: [(v) => !!v || "LO is required"],
      HostLomCode: "",
      HostLomCodeOptions: [],
      HostLomCodeOptionsLoading: false,

      // For Step 3

      RegistrationTpe: [],

      RegistrationTpeOptions: [
        { value: 1, text: "JCI India Member" },
        { value: 2, text: "JCI India Senior Member" },
        { value: 3, text: "JCOM Member" },
        { value: 4, text: "Non-Member" },
      ],

      ParticipantZoneType: "",

      ParticipantZoneCodeRules: [],
      ParticipantZoneCode: [],
      ParticipantZoneCodeOptions: [(v) => !!v || "Zone is required"],
      ParticipantZoneCodeOptionsLoading: false,

      ParticipantLomType: "",

      ParticipantLomCodeRules: [],
      ParticipantLomCode: [],
      ParticipantLomCodeOptions: [(v) => !!v || "LO is required"],
      ParticipantLomCodeOptionsLoading: false,

      ParticipantNonMember: false,

      ParticipantAllDesignation: false,

      NationalDesigntionType: "",

      NationalDesigntionRules: [],
      NationalDesigntion: [],
      NationalDesigntionOptions: [(v) => !!v || "Designation is required"],
      NationalDesigntionOptionsLoading: false,

      ZoneDesigntionType: "",

      ZoneDesigntionRules: [],
      ZoneDesigntion: [],
      ZoneDesigntionOptions: [(v) => !!v || "Designation is required"],
      ZoneDesigntionOptionsLoading: false,

      LomDesigntionType: "",

      LomDesigntionRules: [],
      LomDesigntion: [],
      LomDesigntionOptions: [(v) => !!v || "Designation is required"],
      LomDesigntionOptionsLoading: false,

      CommitteeDesigntionType: "",

      CommitteeDesigntionRules: [],
      CommitteeDesigntion: [],
      CommitteeDesigntionOptions: [(v) => !!v || "Designation is required"],
      CommitteeDesigntionOptionsLoading: false,

      uploadPercentage: 0,
      rows: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
      RoleId: "",

      ProgramId: "",
      RecordData: {},
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var ProgramId = this.$route.query.v2;
        ProgramId = ProgramId == (null || undefined) ? 0 : ProgramId;
        console.log({ ProgramId });
        this.ProgramId = ProgramId;

        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        } else {
          this.PageTitle = tr.PageTitle;
          this.PageDescription = tr.PageDescription;
          this.FloatingButtonOptions = tr.FloatingButtonOptions;

          var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
          console.log({ CurrentJciYearId });
          this.JciYearCode = CurrentJciYearId;

          var YearName = parseInt(tr.CurrentJciYearName);
          console.log({ YearName });
          this.YearName = YearName;

          var CurrentYearId = this.$session.get("CurrentYearId");
          CurrentYearId = 1;
          CurrentYearId =
            CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
          this.CurrentYearId = CurrentYearId;

          var RoleId = this.$session.get("RoleId");
          RoleId = RoleId == (null || undefined) ? "" : RoleId;
          // RoleId = 4;
          this.RoleId = RoleId;

          this.getTableRecords();
        }
      }
    },
    RecordData: function () {
      console.log("watch RecordData");
      var tr = this.RecordData;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.getPageData();

        this.FromDate = tr.FromDate;
        this.ToDate = tr.ToDate;
        this.CustomName = tr.CustomName;
        this.Venue = tr.VenueDetails;
        this.RegistrationOverallCount = tr.ParticipantLimit;
        this.RegistrationUserCount = tr.UserLimit;
        this.HostType = tr.HostType;
        this.ParticipantZoneType = tr.ParticipantZoneType;
        this.ParticipantLomType = tr.ParticipantLomType;
        this.ParticipantNonMember = tr.ParticipantNonMember;
        this.ParticipantAllDesignation = tr.ParticipantAllDesignation;
        this.NationalDesigntionType = tr.NationalDesigntionType;
        this.ZoneDesigntionType = tr.ZoneDesigntionType;
        this.LomDesigntionType = tr.LomDesigntionType;
        this.CommitteeDesigntionType = tr.CommitteeDesigntionType;
        this.StatusType = tr.Status;
        this.HostZoneCode = tr.HostZoneId;
        this.HostLomCode = tr.HostLomId;
      }
    },
    CopyMobileNo: function () {
      console.log("watch CopyMobileNo");
      var CopyMobileNo = this.CopyMobileNo;
      this.WhatsappNo = CopyMobileNo == 1 ? this.MobileNo : this.WhatsappNo;
    },
    BloodGroupIdOptions: function () {
      console.log("watch BloodGroupIdOptions");
      this.LoadingFlag = false;
      this.BloodGroupIdOptionsLoading = false;
    },
    EventType: function () {
      console.log("watch EventType");
      this.getEventTypeDetails();
    },
    EventTypeOptions: function () {
      console.log("watch EventTypeOptions");
      this.EventTypeOptionsLoading = false;
      this.EventType = this.RecordData.ProgramTypeId;
    },
    StateIdOptions: function () {
      console.log("watch StateIdOptions");
      this.LoadingFlag = false;
      this.StateIdOptionsLoading = false;
      var rows = this.RecordData;
      var n1 =
        typeof rows === "object" && rows !== null
          ? Object.keys(rows).length
          : 0;
      console.log({ n1 });
      if (n1 > 0) {
        var StateCode = rows.StateId;
        console.log({ StateCode });
        this.StateId = StateCode;
      }
    },
    StateId: function () {
      console.log("watch StateId");
      this.getDistrictIdOptions();
    },
    DistrictIdOptions: function () {
      console.log("watch DistrictIdOptions");
      this.LoadingFlag = false;
      this.DistrictIdOptionsLoading = false;
      var rows = this.RecordData;
      var n1 =
        typeof rows === "object" && rows !== null
          ? Object.keys(rows).length
          : 0;
      console.log({ n1 });
      if (n1 > 0) {
        var DistrictCode = rows.DistrictId;
        console.log({ DistrictCode });
        var idx = this.DistrictIdOptions.map((e) => e.value).indexOf(
          DistrictCode
        );
        console.log("idx=" + idx);
        this.DistrictId = idx >= 0 ? DistrictCode : "";
      }
    },
    DistrictId: function () {
      console.log("watch DistrictId");
      this.getCityIdOptions();
    },
    CityIdOptions: function () {
      console.log("watch CityIdOptions");
      this.LoadingFlag = false;
      this.CityIdOptionsLoading = false;
      var rows = this.RecordData;
      var n1 =
        typeof rows === "object" && rows !== null
          ? Object.keys(rows).length
          : 0;
      console.log({ n1 });
      if (n1 > 0) {
        var CityCode = rows.CityId;
        console.log({ CityCode });
        var idx = this.CityIdOptions.map((e) => e.value).indexOf(CityCode);
        console.log("idx=" + idx);
        this.CityId = idx >= 0 ? CityCode : "";
      }
    },
    HostZoneCode: function () {
      console.log("watch HostZoneCode");
      this.getHostLomCodeOptions();
    },
    HostZoneCodeOptions: function () {
      console.log("watch HostZoneCodeOptions");
      this.HostZoneCodeOptionsLoading = false;
    },
    HostType: function () {
      console.log("watch HostType");
      var HostType = this.HostType;
      console.log({ HostType });
      if (!HostType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        var id1 = n1 > 0 ? rows.HostZoneId : "";
        console.log({ id1 });
        this.HostZoneCode = id1;
      }
    },
    HostLomCodeOptions: function () {
      console.log("watch HostLomCodeOptions");
      this.LoadingFlag = false;
      this.HostLomCodeOptionsLoading = false;
      var rows = this.RecordData;
      var n1 =
        typeof rows === "object" && rows !== null
          ? Object.keys(rows).length
          : 0;
      console.log({ n1 });
      var id1 = n1 > 0 ? rows.HostLomId : "";
      console.log({ id1 });
      var idx = this.HostLomCodeOptions.map((e) => e.value).indexOf(id1);
      console.log({ idx });
      this.HostLomCode = idx >= 0 ? id1 : "";
    },
    ParticipantZoneType: function () {
      console.log("watch ParticipantZoneType");
      var ParticipantZoneType = this.ParticipantZoneType;
      console.log({ ParticipantZoneType });
      var defaultValue = [];
      if (!ParticipantZoneType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.ParticipantZoneId : [];
      }
      console.log({ defaultValue });
      this.ParticipantZoneCode = defaultValue;
    },
    ParticipantZoneCode: function () {
      console.log("watch ParticipantZoneCode");
      this.getParticipantLomCodeOptions();
    },
    ParticipantZoneCodeOptions: function () {
      console.log("watch ParticipantZoneCodeOptions");
      this.ParticipantZoneCodeOptionsLoading = false;
    },
    ParticipantLomCodeOptions: function () {
      console.log("watch ParticipantLomCodeOptions");
      this.ParticipantLomCodeOptionsLoading = false;
    },
    ParticipantLomType: function () {
      console.log("watch ParticipantLomType");
      var ParticipantLomType = this.ParticipantLomType;
      console.log({ ParticipantLomType });
      var defaultValue = [];
      if (!ParticipantLomType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.ParticipantLomId : [];
      }
      console.log({ defaultValue });
      this.ParticipantLomCode = defaultValue;
    },
    ParticipantAllDesignation: function () {
      console.log("watch ParticipantAllDesignation");
      var ParticipantAllDesignation = this.ParticipantAllDesignation;
      console.log({ ParticipantAllDesignation });
      var ParticipantAllDesignationFlag =
        ParticipantAllDesignation == 1 ? false : true;
      console.log({ ParticipantAllDesignationFlag });
      this.ParticipantAllDesignationFlag = ParticipantAllDesignationFlag;
      if (!ParticipantAllDesignationFlag) {
        this.NationalDesigntionType = false;
        this.NationalDesigntion = [];
        this.ZoneDesigntionType = false;
        this.ZoneDesigntion = [];
        this.LomDesigntionType = false;
        this.LomDesigntion = [];
        this.CommitteeDesigntionType = false;
        this.CommitteeDesigntion = [];
      }
    },
    NationalDesigntionType: function () {
      console.log("watch NationalDesigntionType");
      var NationalDesigntionType = this.NationalDesigntionType;
      console.log({ NationalDesigntionType });
      var defaultValue = [];
      if (!NationalDesigntionType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.NationalDesigntion : [];
      }
      console.log({ defaultValue });
      this.NationalDesigntion = defaultValue;
    },
    NationalDesigntionOptions: function () {
      console.log("watch NationalDesigntionOptions");
      this.NationalDesigntionOptionsLoading = false;
    },
    ZoneDesigntionType: function () {
      console.log("watch ZoneDesigntionType");
      var ZoneDesigntionType = this.ZoneDesigntionType;
      console.log({ ZoneDesigntionType });
      var defaultValue = [];
      if (!ZoneDesigntionType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.ZoneDesigntion : [];
      }
      console.log({ defaultValue });
      this.ZoneDesigntion = defaultValue;
    },
    ZoneDesigntionOptions: function () {
      console.log("watch ZoneDesigntionOptions");
      this.ZoneDesigntionOptionsLoading = false;
    },
    LomDesigntionType: function () {
      console.log("watch LomDesigntionType");
      var LomDesigntionType = this.LomDesigntionType;
      console.log({ LomDesigntionType });
      var defaultValue = [];
      if (!LomDesigntionType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.LomDesigntion : [];
      }
      console.log({ defaultValue });
      this.LomDesigntion = defaultValue;
    },
    LomDesigntionOptions: function () {
      console.log("watch LomDesigntionOptions");
      this.LomDesigntionOptionsLoading = false;
    },
    CommitteeDesigntionType: function () {
      console.log("watch CommitteeDesigntionType");
      var CommitteeDesigntionType = this.CommitteeDesigntionType;
      console.log({ CommitteeDesigntionType });
      var defaultValue = [];
      if (!CommitteeDesigntionType) {
        var rows = this.RecordData;
        var n1 =
          typeof rows === "object" && rows !== null
            ? Object.keys(rows).length
            : 0;
        console.log({ n1 });
        defaultValue = n1 > 0 ? rows.CommitteeDesigntion : [];
      }
      console.log({ defaultValue });
      this.CommitteeDesigntion = defaultValue;
    },
    CommitteeDesigntionOptions: function () {
      console.log("watch CommitteeDesigntionOptions");
      this.CommitteeDesigntionOptionsLoading = false;
    },
  },
  methods: {
    remove(item, id = 1) {
      console.log("remove called");
      console.log({ item });
      console.log({ id });
      var index = "";
      switch (id) {
        case 1:
          index = this.ParticipantZoneCode.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.ParticipantZoneCode.splice(index, 1);
          break;

        case 2:
          index = this.NationalDesigntion.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.NationalDesigntion.splice(index, 1);
          break;

        case 3:
          index = this.ZoneDesigntion.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.ZoneDesigntion.splice(index, 1);
          break;

        case 4:
          index = this.LomDesigntion.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.LomDesigntion.splice(index, 1);
          break;

        case 5:
          index = this.CommitteeDesigntion.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.CommitteeDesigntion.splice(index, 1);
          break;

        case 6:
          index = this.ParticipantLomCode.indexOf(item.value);
          console.log({ index });
          if (index >= 0) this.ParticipantLomCode.splice(index, 1);
          break;

        default:
          break;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      //   this.resetForm();
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_events",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getPageData() {
      console.log("getPageData called");
      var yearCode = this.JciYearCode;
      console.log({ yearCode });
      this.getEventTypeOptions();
      this.getStateIdOptions();

      // get participant zone options
      this.ParticipantZoneCode = "";
      this.ParticipantZoneCodeOptionsLoading = true;
      this.getZoneCodeOptions(
        "ParticipantZoneCode",
        "ParticipantZoneCodeOptions",
        {
          UserInterface: 2,
          YearCode: yearCode,
        }
      );

      // get host zone options

      this.HostZoneCode = "";
      this.HostZoneCodeOptionsLoading = true;
      this.getZoneCodeOptions("HostZoneCode", "HostZoneCodeOptions", {
        UserInterface: 2,
        YearCode: yearCode,
      });

      // get NGB designation options

      this.NationalDesigntion = "";
      this.NationalDesigntionOptionsLoading = true;
      this.getDesignationOptions(
        "NationalDesigntion",
        "NationalDesigntionOptions",
        {
          UserInterface: 4,
          OrganizationTypeId: 1,
          CategorySubName: "designation_national",
        }
      );

      // get ZGB designation options

      this.ZoneDesigntion = "";
      this.ZoneDesigntionOptionsLoading = true;
      this.getDesignationOptions("ZoneDesigntion", "ZoneDesigntionOptions", {
        UserInterface: 4,
        OrganizationTypeId: 2,
        CategorySubName: "designation_zone",
      });

      // get LGB designation options

      this.LomDesigntion = "";
      this.LomDesigntionOptionsLoading = true;
      this.getDesignationOptions("LomDesigntion", "LomDesigntionOptions", {
        UserInterface: 4,
        OrganizationTypeId: 3,
        CategorySubName: "designation_lo",
      });

      // get Committee designation options

      this.CommitteeDesigntion = "";
      this.CommitteeDesigntionOptionsLoading = true;
      this.getDesignationOptions(
        "CommitteeDesigntion",
        "CommitteeDesigntionOptions",
        {
          UserInterface: 4,
          OrganizationTypeId: 1,
          CategorySubName: "designation_national_committee",
        }
      );
    },
    resetForm() {
      //   this.$refs.form1.reset();
      this.$refs.form2.reset();
      this.$refs.form3.reset();
      this.$refs.form4.reset();
    },
    getEventTypeDetails() {
      console.log("getEventTypeDetails called");
      this.AllMembers = [];
      var temp_code = this.EventType;
      console.log("temp_code=" + temp_code);
      var idx = this.EventTypeOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var item = this.EventTypeOptions[idx];
        console.log({ item });
        this.SelectedEventType = item;
      }
    },
    getZoneCodeOptions(source, destination, request) {
      console.log("getZoneCodeOptions called");
      if (source != "" && destination != "") {
        var selectbox1_url = "api/year-wise-lom/zone-options";
        this.getSelectBoxOptions(source, destination, request, selectbox1_url);
      }
    },
    getDesignationOptions(source, destination, request) {
      console.log("getDesignationOptions called");
      if (source != "" && destination != "") {
        var selectbox1_url = "api/designation/options";
        this.getSelectBoxOptions(source, destination, request, selectbox1_url);
      }
    },
    getHostLomCodeOptions() {
      console.log("getHostLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var HostZoneCode = this.HostZoneCode;
      this.HostLomCode = "";
      console.log("YearCode=" + YearCode + ", HostZoneCode=" + HostZoneCode);
      if (YearCode != "" && HostZoneCode != "") {
        this.LoadingFlag = true;
        this.HostLomCodeOptionsLoading = true;
        var selectbox1_source = "HostLomCode";
        var selectbox1_destination = "HostLomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: HostZoneCode,
          AllOption: 0,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (HostZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getParticipantLomCodeOptions() {
      console.log("getParticipantLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ParticipantZoneCode = this.ParticipantZoneCode;
      this.ParticipantLomCode = [];
      console.log("YearCode=" + YearCode);
      console.log({ ParticipantZoneCode });
      var t1 = ParticipantZoneCode.length;
      console.log({ t1 });
      if (YearCode != "" && t1 > 0) {
        this.ParticipantLomCodeOptionsLoading = true;
        var selectbox1_source = "ParticipantLomCode";
        var selectbox1_destination = "ParticipantLomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: this.HostZoneCode,
          AllOption: 0,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (t1 == 0) {
          message += "Atleast one zone required. ";
        }
        this.toast("error", message);
      }
    },
    getEventTypeOptions() {
      console.log("getEventTypeOptions called");
      this.EventType = "";
      this.EventTypeOptionsLoading = true;
      var selectbox1_source = "EventType";
      var selectbox1_destination = "EventTypeOptions";
      var selectbox1_url = "api/jci-program-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getStateIdOptions() {
      console.log("getStateIdOptions called");
      this.LoadingFlag = true;
      this.StateIdOptionsLoading = true;
      var selectbox1_source = "StateId";
      var selectbox1_destination = "StateIdOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictIdOptions() {
      console.log("getDistrictIdOptions called");
      var StateId = this.StateId;
      console.log({ StateId });
      if (StateId != "") {
        this.LoadingFlag = true;
        this.DistrictIdOptionsLoading = true;
        var selectbox1_source = "DistrictId";
        var selectbox1_destination = "DistrictIdOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityIdOptions() {
      console.log("getCityIdOptions called");
      var DistrictId = this.DistrictId;
      if (DistrictId != "") {
        this.LoadingFlag = true;
        this.CityIdOptionsLoading = true;
        var selectbox1_source = "CityId";
        var selectbox1_destination = "CityIdOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    validateStep(step) {
      console.log("validateStep step=" + step);
      var flag = false;
      var submitFlag = false;
      var validate = false;
      var nextStep = 0;
      var message = "Kindly fill the required fields. ";
      switch (step) {
        case 1:
          validate = this.$refs.form3.validate();
          message = validate ? "" : message;
          console.log({ validate });

          var FromDate = this.FromDate;
          var ToDate = this.ToDate;
          flag = validate && FromDate != "" && ToDate != "" ? true : false;
          console.log({ flag });

          message += FromDate == "" ? "From Date should not be empty. " : "";
          message += ToDate == "" ? "To Date should not be empty. " : "";

          nextStep = 2;
          // flag = true;

          break;

        case 2:
          validate = this.$refs.form2.validate();
          message = validate ? "" : message;
          console.log({ validate });

          flag = validate ? true : false;
          console.log({ flag });

          nextStep = 3;
          // flag = true;
          break;

        case 3:
          validate = this.$refs.form1.validate();
          message = validate ? "" : message;
          console.log({ validate });

          var ParticipantZoneType = this.ParticipantZoneType;
          console.log({ ParticipantZoneType });

          var ParticipantZoneCodeCount = this.ParticipantZoneCode.length;
          console.log({ ParticipantZoneCodeCount });

          var ParticipantZoneCodeFlag =
            !ParticipantZoneType && ParticipantZoneCodeCount == 0
              ? false
              : true;
          console.log({ ParticipantZoneCodeFlag });

          var ParticipantLomType = this.ParticipantLomType;
          console.log({ ParticipantLomType });

          var ParticipantLomCodeCount = this.ParticipantLomCode.length;
          console.log({ ParticipantLomCodeCount });

          var ParticipantLomCodeFlag =
            !ParticipantZoneType &&
            !ParticipantLomType &&
            ParticipantLomCodeCount == 0
              ? false
              : true;
          console.log({ ParticipantLomCodeFlag });

          var ParticipantNonMember = this.ParticipantNonMember;
          console.log({ ParticipantNonMember });

          var ParticipantAllDesignation = this.ParticipantAllDesignation;
          console.log({ ParticipantAllDesignation });

          var flag1 =
            !ParticipantZoneCodeFlag || !ParticipantLomCodeFlag ? false : true;
          console.log({ flag1 });

          message += !ParticipantZoneCodeFlag
            ? "Select atleast one zone. "
            : "";

          message += !ParticipantLomCodeFlag ? "Select atleast one LO. " : "";

          var flag2 = true;

          if (!ParticipantAllDesignation) {
            var NationalDesigntionType = this.NationalDesigntionType;
            console.log({ NationalDesigntionType });

            var NationalDesigntionCount = this.NationalDesigntion.length;
            console.log({ NationalDesigntionCount });

            var ZoneDesigntionType = this.ZoneDesigntionType;
            console.log({ ZoneDesigntionType });

            var ZoneDesigntionCount = this.ZoneDesigntion.length;
            console.log({ ZoneDesigntionCount });

            var LomDesigntionType = this.LomDesigntionType;
            console.log({ LomDesigntionType });

            var LomDesigntionCount = this.LomDesigntion.length;
            console.log({ LomDesigntionCount });

            var CommitteeDesigntionType = this.CommitteeDesigntionType;
            console.log({ CommitteeDesigntionType });

            var CommitteeDesigntionCount = this.CommitteeDesigntion.length;
            console.log({ CommitteeDesigntionCount });

            var TotalDesignationCount =
              parseInt(NationalDesigntionCount) +
              parseInt(ZoneDesigntionCount) +
              parseInt(LomDesigntionCount) +
              parseInt(CommitteeDesigntionCount);
            console.log({ TotalDesignationCount });

            var flag2 =
              !ParticipantAllDesignation && TotalDesignationCount == 0
                ? false
                : true;
            console.log({ flag2 });

            message += !flag2
              ? "Atleast one designation should be selected in NGB or ZGB or LGB or Committee. "
              : "";
          }
          console.log({ flag1 });
          console.log({ flag2 });

          flag = flag1 && flag2 ? true : false;

          nextStep = 4;
          submitFlag = true;
          break;

        case 4:
          validate = this.$refs.form4.validate();
          flag = validate ? true : false;
          nextStep = 5;
          break;

        default:
          break;
      }
      console.log(
        "flag=" + flag + ", nextStep=" + nextStep + ", submitFlag=" + submitFlag
      );
      if (flag) {
        if (submitFlag) {
          this.confirmAlert();
        } else {
          this.step = nextStep;
        }
      } else {
        // this.sweetAlert("error", "Kindly fill the required * fields", false);
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this! Kindly check the information are correct",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Continue`,
        confirmButtonColor: "#3085d6",
        cancelButtonText: `Cancel`,
        cancelButtonColor: "#d33",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.submitForm();
        } else {
          this.sweetAlert("error", "You cancelled the process", true);
        }
      });
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jci-program/show";
      var upload = {
        UserInterface: 1,
        Program: this.ProgramId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.LoadingFlag = true;
      this.RecordData = {};

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.LoadingFlag = false;
            thisIns.RecordData = records;
            thisIns.toast("success", output);
          } else {
            thisIns.LoadingFlag = false;
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
        });
    },
    submitForm() {
      console.log("submitForm is called");

      var ParticipantZoneCode = this.ParticipantZoneCode;
      var ParticipantLomCode = this.ParticipantLomCode;
      var NationalDesigntion = this.NationalDesigntion;
      var ZoneDesigntion = this.ZoneDesigntion;
      var LomDesigntion = this.LomDesigntion;
      var CommitteeDesigntion = this.CommitteeDesigntion;

      var RecordData = this.RecordData;
      console.log({ RecordData });

      var ProgramId = RecordData.ProgramId;
      console.log({ ProgramId });

      var upload = {
        UserInterface: 1,
        Event: ProgramId,
        Year: RecordData.YearId,
        EventType: this.EventType,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        CustomName: this.CustomName,
        Venue: this.Venue,
        City: this.CityId,
        RegistrationOverallCount: this.RegistrationOverallCount,
        RegistrationUserCount: this.RegistrationUserCount,
        HostType: this.HostType,
        HostZone: this.HostZoneCode,
        HostLom: this.HostLomCode,
        ParticipantZoneType: this.ParticipantZoneType,
        ParticipantZone:
          ParticipantZoneCode.length > 0 ? ParticipantZoneCode : null,
        ParticipantLomType: this.ParticipantLomType,
        ParticipantLom:
          ParticipantLomCode.length > 0 ? ParticipantLomCode : null,
        ParticipantNonMember: this.ParticipantNonMember,
        ParticipantAllDesignation: this.ParticipantAllDesignation,
        NationalDesigntionType: this.NationalDesigntionType,
        NationalDesigntion:
          NationalDesigntion.length > 0 ? NationalDesigntion : null,
        ZoneDesigntionType: this.ZoneDesigntionType,
        ZoneDesigntion: ZoneDesigntion.length > 0 ? ZoneDesigntion : null,
        LomDesigntionType: this.LomDesigntionType,
        LomDesigntion: LomDesigntion.length > 0 ? LomDesigntion : null,
        CommitteeDesigntionType: this.CommitteeDesigntionType,
        CommitteeDesigntion:
          CommitteeDesigntion.length > 0 ? CommitteeDesigntion : null,
        StatusType: this.StatusType,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/jci-program/update";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.SubmitFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.$router.push("/jci-event/report");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
        });
    },
  },
  beforeMount() {
    console.log("jci-program-create beforeMount");

    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(
  135deg,
  $primary-color 0%,
  $secondary-color 100%
);
$card-shadow: 0 16px 48px rgba(102, 126, 234, 0.15);
$input-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
$success-color: #10b981;
$grey-color: #6c757d;

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

#jci-program-create {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;
  animation: fadeIn 0.6s ease-in-out;

  // Premium Header Styles
  .premium-header-card {
    background: $gradient-main !important;
    border-radius: 16px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.4);

    .header-gradient-bg {
      position: relative;
      overflow: hidden;

      .header-backdrop-effect {
        position: absolute;
        width: 300px;
        height: 300px;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.15) 0%,
          rgba(255, 255, 255, 0) 70%
        );
        border-radius: 50%;
        top: -100px;
        right: -100px;
        animation: float 6s ease-in-out infinite;
      }
    }

    .header-content {
      position: relative;
      z-index: 1;

      .header-icon-box {
        width: 60px;
        height: 60px;
        background: rgba(255, 255, 255, 0.25);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        animation: float 4s ease-in-out infinite;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
      }

      .header-title {
        font-size: 32px;
        font-weight: 800;
        letter-spacing: -0.5px;
        animation: slideInLeft 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s
          backwards;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .header-subtitle {
        font-size: 14px;
        opacity: 0.98;
        animation: slideInLeft 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s
          backwards;
        font-weight: 500;
      }

      .step-progress-chip {
        animation: fadeInUp 0.8s ease-out 0.3s backwards;
        backdrop-filter: blur(10px);
        font-weight: 700;
        letter-spacing: 0.5px;
      }
    }
  }

  // Modern Stepper Styles
  .modern-stepper {
    border-radius: 14px;
    background: white !important;
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
    animation: cardSlideIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s backwards;
    border: none;

    .stepper-header-modern {
      background: linear-gradient(
        135deg,
        rgba(102, 126, 234, 0.08) 0%,
        rgba(118, 75, 162, 0.08) 100%
      );
      border-radius: 14px 14px 0 0;
      padding: 32px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid rgba(102, 126, 234, 0.15);

      .modern-step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        animation: fadeInUp 0.8s ease-out;

        .step-icon-circle {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: linear-gradient(135deg, #e0e7ff 0%, #f3e8ff 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 12px;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 0 6px 16px rgba(102, 126, 234, 0.15);
          border: 2px solid rgba(102, 126, 234, 0.1);

          &.active {
            background: $gradient-main;
            box-shadow: 0 12px 28px rgba(102, 126, 234, 0.4);
            transform: scale(1.15);
            border: 2px solid white;

            svg {
              animation: float 2s ease-in-out infinite;
              filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
            }
          }
        }

        .step-text {
          font-size: 13px;
          font-weight: 700;
          color: #2c3e50;
          text-align: center;
          letter-spacing: 0.4px;
          text-transform: uppercase;
        }
      }

      .step-divider-line {
        flex: 1;
        height: 3px;
        background: linear-gradient(90deg, #e0e7ff 0%, transparent 100%);
        margin: 0 16px;
        transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);

        &.active {
          background: $gradient-main;
          box-shadow: 0 0 12px rgba(102, 126, 234, 0.5);
        }
      }
    }
  }

  // Premium Card Styling
  .premium-card-modern {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
    animation: cardSlideIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    background: white !important;
    border: none;
    margin-top: 24px;

    .card-header-gradient {
      background: $gradient-main;
      position: relative;
      overflow: hidden;
      padding: 0;

      .card-header-backdrop {
        position: absolute;
        width: 400px;
        height: 400px;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.2) 0%,
          rgba(255, 255, 255, 0) 70%
        );
        border-radius: 50%;
        top: -150px;
        right: -100px;
        animation: rotate 20s linear infinite;
      }

      .card-header-modern {
        position: relative;
        z-index: 1;
        padding: 32px;

        .card-icon-badge {
          width: 72px;
          height: 72px;
          background: rgba(255, 255, 255, 0.25);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
          animation: float 4s ease-in-out infinite;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          border: 2px solid rgba(255, 255, 255, 0.3);
        }

        .card-header-title {
          font-size: 26px;
          font-weight: 800;
          letter-spacing: -0.3px;
          animation: slideInLeft 0.8s ease-out 0.1s backwards;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .card-header-subtitle {
          font-size: 13px;
          opacity: 0.95;
          animation: slideInLeft 0.8s ease-out 0.2s backwards;
          font-weight: 500;
        }
      }
    }

    .card-body-modern {
      padding: 36px;
      background: linear-gradient(135deg, #ffffff 0%, #f9fbff 100%);

      // Info Banner
      .info-banner {
        padding: 16px 20px;
        background: linear-gradient(
          135deg,
          rgba(102, 126, 234, 0.12) 0%,
          rgba(118, 75, 162, 0.12) 100%
        );
        border-left: 5px solid $primary-color;
        border-radius: 10px;
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #2c3e50;
        animation: slideInLeft 0.6s ease-out 0.3s backwards;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);

        svg {
          margin-right: 12px;
          animation: pulse 2s ease-in-out infinite;
        }
      }

      // Form Field Styling
      .form-field-label {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: #2c3e50;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 12px;

        svg {
          animation: pulse 2s ease-in-out infinite;
        }

        .text-danger {
          color: #ef4444;
          margin: 0 6px;
          font-weight: 900;
        }

        .text-muted {
          color: #9ca3af;
          font-size: 11px;
          font-weight: 500;
          text-transform: none;
          letter-spacing: 0;
        }
      }

      .field-input {
        animation: fadeInUp 0.6s ease-out 0.4s backwards !important;

        ::v-deep {
          .v-input__control {
            position: relative;
            z-index: 1;
          }

          .v-text-field__slot input,
          .v-select__slot,
          .v-autocomplete__input {
            font-size: 14px;
            font-weight: 600;
            color: #2c3e50;
          }

          .v-text-field--outlined .v-text-field__control {
            height: 48px;
          }

          fieldset {
            border-color: #d1dae8 !important;
            border-width: 2px !important;
            transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          }

          &:hover fieldset {
            border-color: $primary-color !important;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }

          &.v-input--is-focused fieldset {
            border-color: $primary-color !important;
            box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15);
          }
        }
      }

      // Info Cards
      .info-card {
        background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
        border-left: 4px solid $primary-color;
        border-radius: 10px;
        padding: 18px;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        animation: fadeInUp 0.6s ease-out 0.5s backwards;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);

        &:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 32px rgba(102, 126, 234, 0.25);
          border-left-color: $secondary-color;
        }

        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          h6 {
            font-size: 13px;
            font-weight: 800;
            color: #2c3e50;
            letter-spacing: 0.3px;
            text-transform: uppercase;
          }
        }

        .info-text {
          font-size: 13px;
          color: #5a6c7d;
          line-height: 1.7;
          font-weight: 500;
        }
      }

      // Designation Section
      .designation-section {
        padding: 28px;
        background: linear-gradient(135deg, #f3f4f6 0%, #fafbfc 100%);
        border-radius: 12px;
        margin-top: 24px;
        border: 2px dashed rgba(102, 126, 234, 0.2);

        h5 {
          font-size: 14px;
          color: #2c3e50;
          margin-bottom: 20px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }
      }
    }

    // Card Actions
    .card-actions-modern {
      background: linear-gradient(135deg, #f9fbff 0%, #ffffff 100%);
      padding: 24px 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 2px solid rgba(102, 126, 234, 0.1);

      .action-btn {
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        border-radius: 10px;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        animation: fadeInUp 0.6s ease-out 0.6s backwards;
        font-size: 12px;
        padding: 12px 28px !important;
        min-width: 140px;

        &.continue-btn {
          background: $gradient-main !important;
          color: white !important;
          border: none;

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 12px 28px rgba(102, 126, 234, 0.4);
          }

          &:active {
            transform: translateY(-1px);
          }
        }

        &.previous-btn {
          background: linear-gradient(
            135deg,
            #e0e7ff 0%,
            #d1ddef 100%
          ) !important;
          color: $primary-color !important;
          border: none;

          &:hover {
            background: linear-gradient(
              135deg,
              #d1ddef 0%,
              #c9d5e8 100%
            ) !important;
            transform: translateY(-3px);
            box-shadow: 0 12px 28px rgba(102, 126, 234, 0.25);
          }
        }

        &.submit-btn {
          background: linear-gradient(
            135deg,
            $success-color 0%,
            #059669 100%
          ) !important;
          color: white !important;
          border: none;

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 12px 28px rgba(16, 185, 129, 0.4);
          }

          &:active {
            transform: translateY(-1px);
          }
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 1200px) {
    .premium-header-card {
      .header-content {
        .header-title {
          font-size: 24px;
        }
      }
    }

    .premium-card-modern {
      .card-body-modern {
        padding: 24px;
      }

      .card-actions-modern {
        padding: 16px 24px;
        flex-wrap: wrap;

        .action-btn {
          flex: 1;
          min-width: 120px;
          margin: 0 8px;
        }
      }
    }
  }

  @media (max-width: 960px) {
    padding: 20px 10px;

    .premium-header-card {
      margin-bottom: 24px;

      .header-content {
        padding: 20px !important;

        .d-flex {
          flex-direction: column;
          text-align: center;

          .header-icon-box {
            margin-bottom: 16px;
          }

          .header-title {
            font-size: 20px;
          }

          .header-subtitle {
            font-size: 12px;
          }

          .step-progress-chip {
            margin-top: 12px;
          }
        }
      }
    }

    .modern-stepper {
      .stepper-header-modern {
        flex-direction: column;
        gap: 20px;

        .modern-step-item {
          width: 100%;

          .step-icon-circle {
            width: 48px;
            height: 48px;
          }
        }

        .step-divider-line {
          display: none;
        }
      }
    }

    .premium-card-modern {
      .card-body-modern {
        padding: 16px;
      }

      .card-actions-modern {
        flex-direction: column;
        gap: 12px;

        .action-btn {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .premium-header-card {
      .header-content {
        .header-icon-box {
          width: 48px;
          height: 48px;
        }

        .header-title {
          font-size: 18px;
        }

        .header-subtitle {
          font-size: 11px;
        }

        .step-progress-chip {
          font-size: 11px;
        }
      }
    }

    .modern-stepper {
      .stepper-header-modern {
        padding: 16px;

        .modern-step-item {
          .step-icon-circle {
            width: 40px;
            height: 40px;

            svg {
              font-size: 18px !important;
            }
          }

          .step-text {
            font-size: 11px;
          }
        }
      }
    }

    .premium-card-modern {
      .card-header-gradient {
        .card-header-modern {
          .card-icon-badge {
            width: 48px;
            height: 48px;
          }

          .card-header-title {
            font-size: 18px;
          }

          .card-header-subtitle {
            font-size: 12px;
          }
        }
      }

      .card-body-modern {
        padding: 12px;

        .info-banner {
          font-size: 12px;
          padding: 10px 12px;
        }

        .form-field-label {
          font-size: 12px;
        }
      }

      .card-actions-modern {
        padding: 12px;

        .action-btn {
          font-size: 12px;
          padding: 10px 16px !important;
        }
      }
    }
  }

  // Original Styles (kept for compatibility)
  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  .v-card__subtitle,
  .v-card__text {
    font-size: 16px;
  }

  .v-list-item--dense .v-list-item__title,
  .v-list-item--dense .v-list-item__subtitle,
  .v-list--dense .v-list-item .v-list-item__title,
  .v-list--dense .v-list-item .v-list-item__subtitle {
    font-size: 18px !important;
  }

  .mycard-text1 {
    font-family: sans-serif;
  }

  .fsize-3 {
    font-size: 16px !important;
  }
}
</style>